import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  AppBar,
  Toolbar,
  IconButton,
  TextField,
  Button,
  Pagination,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Ícono de retroceso
import { UrlApiEnvasado } from "../../../../../services/apirest";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import moment from "moment/moment";
import PersonIcon from "@mui/icons-material/Person";
import PropaneTankIcon from "@mui/icons-material/PropaneTank";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useFechas } from "../../../context/FechaContext";
import { useLocation, useNavigate } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import { PieChart } from "@mui/x-charts";
import { useTheme } from "@mui/styles";
import { number } from "prop-types";
import { pieArcLabelClasses } from '@mui/x-charts/PieChart';
function RankingVulnera() {
  let location = useLocation();
  const navigate = useNavigate(); // Hook para navegación
  const {
    desdeButano,
    hastaButano,
    desdePropano,
    hastaPropano,
    setDesdeButano,
    setHastaButano,
    setDesdePropano,
    setHastaPropano,
  } = useFechas();
  const [desde, setDesde] = useState(
    location.state.tabla === "Butano" ? desdeButano : desdePropano
  );
  const [hasta, setHasta] = useState(
    location.state.tabla === "Butano" ? hastaButano : hastaPropano
  );
  const [topClientes, setTopClientes] = useState([]);
  const [loadingTopClientes, setLoadingTopClientes] = useState();

  const [kgTipos, setKgTipos] = useState([]);
  const [loadingKgTipos, setLoadingKgTipos] = useState();

  useEffect(() => {
    if (location.state.tabla === "Butano") {
      setDesdeButano(desde);
      setHastaButano(hasta);
    } else {
      setDesdePropano(desde);
      setHastaPropano(hasta);
    }
  }, [desde, hasta]);
// console.log(location.state);

  const [origen, setOrigen] = useState("");
  useEffect(() => {
    if (location.state.row.origen === "bk1_aws_hipergas") {
      setOrigen("api/estadistica");
    } else if (location.state.row.origen === "bk1_aws_aogas") {
      setOrigen("db2/api/estadisticaaogas");
    }
  }, [location.state]);

  // TopMoviles
  const obtenerRanking = async () => {
    setLoadingTopClientes(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}${origen}/xsucursal/rankingvulnerabilidad/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setTopClientes(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingTopClientes(false);
    }
  };

  const obtenerKgTipos = async () => {
    setLoadingKgTipos(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}${origen}/xsucursal/totalkgvulnerabilidad/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setKgTipos(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingKgTipos(false);
    }
  };

  useEffect(() => {
    if (origen !== "") {
      obtenerRanking();
      obtenerKgTipos();
    }
  }, [origen]);

  const handleUpdate = () => {
    obtenerRanking();
    obtenerKgTipos();
  };
  // console.log(topClientes, kgTipos);

  // *********************************************************************************** //
  const COLORS = [
    "#FF6384",
    "#36A2EB",
    "#FFCE56",
    "#4BC0C0",
    "#9966FF",
    "#FF9F40",
    "#8BC34A",
    "#E91E63",
    "#00BCD4",
    "#CDDC39",
  ];

  const totalButano = kgTipos && kgTipos[0] ? kgTipos[0].total_kilos_butano : 0;
  const totalPropano =
    kgTipos && kgTipos[0] ? kgTipos[0].total_kilos_propano : 0;
  const totalGeneral = totalButano + totalPropano;
  const colorOffset = 6;

  return (
    <div style={{ backgroundColor: "#d7d7d7" }}>
      <AppBar position="static" sx={{ backgroundColor: "#1F618D" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
            Ranking de Vulnerabilidad de {location.state.row.nombre_sucursal}
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ 
        backgroundColor: "#f8fafc", 
        minHeight: "100vh", 
        p: 3,
        transition: "all 0.3s ease"
      }}>
        {/* Contenido del Panel */}
        <Grid
          mb={2}
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} md={3}>
            <TextField
              label="Desde"
              type="date"
              value={desde}
              onChange={(e) => setDesde(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#1F618D",
                  },
                  "&:hover fieldset": {
                    borderColor: "#1F618D",
                  },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Hasta"
              type="date"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#1F618D",
                  },
                  "&:hover fieldset": {
                    borderColor: "#1F618D",
                  },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              onClick={handleUpdate}
              size="medium"
              fullWidth
              sx={{
                backgroundColor: "#1F618D",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#154360",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(31, 97, 141, 0.3)",
                },
                transition: "all 0.3s ease",
                height: "40px",
              }}
              startIcon={<RefreshIcon />}
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>

        {/* Top de vulnerabilidad */}
        <Grid item xs={12} md={12}>
          <Card
            sx={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
              boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
              borderRadius: "12px",
              transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
              borderLeft: "4px solid #1F618D",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
              },
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <GroupIcon sx={{ color: "#5D6D7E", fontSize: 28, mr: 1 }} />
                <Typography
                  variant="h6"
                  sx={{
                    color: "#1F618D",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    letterSpacing: "0.5px",
                  }}
                >
                  TOP DE CLIENTES
                </Typography>
              </Box>

              {loadingTopClientes ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px",
                  }}
                >
                  <CircularProgress sx={{ color: "#1F618D" }} />
                </Box>
              ) : (
                <>
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          {/* Columna Cliente */}
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              position: "sticky",
                              left: 0,
                              zIndex: 2,
                            }}
                          >
                            Cliente
                          </TableCell>

                          {/* Columna Butano */}
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#E3F2FD",
                            }}
                          >
                            <Tooltip placement="top" title="El porcentaje está calculado en base al total de kilos de butano vendidos" arrow>
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <LocalFireDepartmentIcon
                                sx={{ color: "#FF6B35", fontSize: 20, mr: 1 }}
                              />
                              BUTANO (kg)
                            </Box>
                            </Tooltip>
                          </TableCell>

                          {/* Columna Propano */}
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#e8f5e9",
                            }}
                          >
                            <Tooltip placement="top" title="El porcentaje está calculado en base al total de kilos de propano vendidos" arrow>
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <LocalFireDepartmentIcon
                                sx={{ color: "#FF8C42", fontSize: 20, mr: 1 }}
                              />
                              PROPANO (kg)
                            </Box>
                            </Tooltip>
                          </TableCell>

                          {/* Columna Total */}
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#fff8e1",
                            }}
                          >
                            <Tooltip placement="top" title="El porcentaje está calculado en base al total de kilos vendidos" arrow>
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <LocalFireDepartmentIcon
                                sx={{ color: "#FFA000", fontSize: 20, mr: 1 }}
                              />
                              TOTAL (kg)
                            </Box>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {topClientes.map((cliente, index) => (
                          <TableRow
                            key={index}
                            hover
                            sx={{ "&:hover": { backgroundColor: "#e9f5ff" } }}
                          >
                            {/* Celda Cliente */}
                            <TableCell
                              sx={{
                                backgroundColor: "#f5f7fa !important",
                                position: "sticky",
                                left: 0,
                                zIndex: 1,
                              }}
                            >
                              {cliente.cliente}
                            </TableCell>

                            {/* Celda Butano */}
                            <TableCell
                              align="right"
                              sx={{
                                backgroundColor:
                                  index % 2 === 0 ? "#E3F2FD" : "#D8EBFD",
                                borderRight: "1px solid #e0e0e0",
                              }}
                            >
                              {cliente.kilos_vendidos_butano || "0"} - <strong>({cliente.kilos_vendidos_butano?((parseInt(cliente.kilos_vendidos_butano || 0)/totalButano)*100).toFixed(2):"0"}%)</strong>
                            </TableCell>

                            {/* Celda Propano */}
                            <TableCell
                              align="right"
                              sx={{
                                backgroundColor:
                                  index % 2 === 0 ? "#e8f5e9" : "#d8edda",
                                borderRight: "1px solid #e0e0e0",
                              }}
                            >
                              {cliente.kilos_vendidos_propano || "0"} - <strong>({cliente.kilos_vendidos_propano?((parseFloat(cliente.kilos_vendidos_propano)/parseFloat(totalPropano))*100).toFixed(2):"0"}%)</strong>
                            </TableCell>

                            {/* Celda Total */}
                            <TableCell
                              align="right"
                              sx={{
                                backgroundColor:
                                  index % 2 === 0 ? "#fff8e1" : "#ffecb3",
                                fontWeight: "bold",
                              }}
                            >
                              {cliente.total_kilos || "0"} - <strong>({cliente.total_kilos?((parseInt(cliente.total_kilos)/totalGeneral)*100).toFixed(2):"0"}%)</strong>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </CardContent>
          </Card>
        </Grid>


      {/* chart */}
      {/* Sección de gráficos */}

      <Grid container spacing={2} mt={2}>
        {/* Gráfico de Total */}
        <Grid item xs={12} md={4}>
          <Card sx={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
              boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
              borderRadius: "12px",
              transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
              borderLeft: "4px solid #1F618D",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
              },
            }}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={3}>
                <LocalFireDepartmentIcon sx={{ color: "#FFA000", mr: 1 }} />
                <Typography
                  variant="h6"
                  sx={{ color: "#1F618D", fontWeight: "bold" }}
                >
                  Total ({totalGeneral || "0"} kg)
                </Typography>
              </Box>

              {loadingKgTipos ? (
                <Box display="flex"
                justifyContent="center"
                alignItems="center"
                height={300}>
                  <CircularProgress sx={{ color: "#1F618D" }} />
                </Box>
              ) : (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ flexWrap: "wrap", gap: 4 }}
                >
                  <Box sx={{ 
                    width: 400, 
                    height: 320,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // marginLeft:12
                  }}>
                    <PieChart
                      series={[
                        {
                          data: [
                            ...topClientes
                              .filter((c) => c.total_kilos > 0)
                              .map((c, i) => ({
                                id: c.id,
                                value:
                                  totalGeneral > 0
                                    ? (c.total_kilos / totalGeneral) * 100
                                    : 0,
                                label: c.cliente,
                                color: COLORS[(i + colorOffset) % COLORS.length],
                                kilos: c.total_kilos,
                                
                              })),
                            {
                              id: "otros-total",
                              value:
                                totalGeneral > 0
                                  ? ((totalGeneral -
                                      topClientes.reduce(
                                        (sum, c) => sum + (c.total_kilos || 0),
                                        0
                                      )) /
                                      totalGeneral) *
                                    100
                                  : 0,
                              label: "Otros",
                              color: "#e0e0e0",
                              kilos: Math.max(
                                0,
                                totalGeneral -
                                  topClientes.reduce(
                                    (sum, c) => sum + (c.total_kilos || 0),
                                    0
                                  )
                              ),
                            },
                          ],
                          innerRadius: 30,
                          paddingAngle: 3,
                          cx: 200,
                          // outerRadius: 80,
                          // paddingAngle: 1,
                          // cornerRadius: 3,
                          arcLabel: (item) =>
                            item.value > 5 ? `${item.value.toFixed(1)}%` : "",
                          highlightScope: {
                            faded: "global",
                            highlighted: "item",
                          },
                          faded: {
                            additionalRadius: -15,
                            color: "gray",
                          },
                        },
                      ]}
                      slotProps={{
                        legend: {
                          hidden: true,
                        },
                        tooltip: {
                          formatter: (value, props) => [
                            { label: "Cliente", value: props.label },
                            {
                              label: "Porcentaje",
                              value: `${value.toFixed(2)}%`,
                            },
                            {
                              label: "Kilos totales",
                              value: `${props.kilos} kg`,
                            },
                            {
                              label: "Total General",
                              value: `${totalGeneral} kg`,
                            },
                          ],
                        },
                      }}
                      width={400}
                      height={300}
                    />
                  </Box>
                  {/* Leyenda personalizada */}
                  <Box sx={{ minWidth: 200 }}>
                    {[
                      ...topClientes
                        // .filter(c => c.kilos_vendidos_butano > 0)
                        .map((c, i) => ({
                          label: c.cliente,
                          color: COLORS[(i + colorOffset) % COLORS.length],
                          kilos:
                            parseInt(c.kilos_vendidos_butano || 0) +
                            parseInt(c.kilos_vendidos_propano || 0),
                        })),
                      {
                        label: "Otros",
                        color: "#e0e0e0",
                        kilos: Math.max(
                          0,
                          totalGeneral -
                            topClientes.reduce(
                              (sum, c) =>
                                sum +
                                (parseInt(c.kilos_vendidos_butano || 0) +
                                  parseInt(c.kilos_vendidos_propano || 0) || 0),
                              0
                            )
                        ),
                      },
                    ].map((item, idx) => (
                      <Box key={idx} display="flex" alignItems="center" mb={1}>
                        <Box
                          sx={{
                            width: 14,
                            height: 14,
                            borderRadius: "50%",
                            backgroundColor: item.color,
                            mr: 1,
                          }}
                        />
                        <Typography variant="body2" sx={{ fontSize: 14 }}>
                          {item.label} — {item.kilos} kg <strong>({item.kilos>0?((item.kilos / totalGeneral)*100).toFixed(2):"0"}%)</strong>
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Gráfico de Butano */}
        <Grid item xs={12} md={4}>
          <Card sx={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
              boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
              borderRadius: "12px",
              transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
              borderLeft: "4px solid #1F618D",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
              },
            }}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={3}>
                <LocalFireDepartmentIcon sx={{ color: "#FF6B35", mr: 1 }} />
                <Typography
                  variant="h6"
                  sx={{ color: "#1F618D", fontWeight: "bold" }}
                >
                  Butano ({totalButano || "0"} kg)
                </Typography>
              </Box>

              {loadingKgTipos ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height={300}
                >
                  <CircularProgress sx={{ color: "#1F618D" }} />
                </Box>
              ) : (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ flexWrap: "wrap", gap: 4 }}
                >
                  {/* PieChart */}
                  <Box sx={{ 
                    width: 400, 
                    height: 320,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // marginLeft:12
                  }}>
                    <PieChart
                      series={[
                        {
                          data: [
                            ...topClientes
                              .filter((c) => c.kilos_vendidos_butano > 0)
                              .map((c, i) => ({
                                id: c.id,
                                value:
                                  totalButano > 0
                                    ? (c.kilos_vendidos_butano / totalButano) *
                                      100
                                    : 0,
                                label: c.cliente,
                                color: COLORS[(i + colorOffset) % COLORS.length],
                                kilos: c.kilos_vendidos_butano,
                              })),
                            {
                              id: "otros-butano",
                              value:
                                totalButano > 0
                                  ? ((totalButano -
                                      topClientes.reduce(
                                        (sum, c) =>
                                          sum + (c.kilos_vendidos_butano || 0),
                                        0
                                      )) /
                                      totalButano) *
                                    100
                                  : 0,
                              label: "Otros",
                              color: "#e0e0e0",
                              kilos: Math.max(
                                0,
                                totalButano -
                                  topClientes.reduce(
                                    (sum, c) =>
                                      sum + (c.kilos_vendidos_butano || 0),
                                    0
                                  )
                              ),
                            },
                          ],
                          // paddingAngle: 2,
                          // cornerRadius: 4
                          cx: 200,
                          innerRadius: 30,
                          paddingAngle: 3,
                          arcLabel: (item) =>
                            item.value > 5 ? `${item.value.toFixed(1)}%` : "",
                          highlightScope: {
                            faded: "global",
                            highlighted: "item",
                          },
                          faded: {
                            additionalRadius: -15,
                            color: "gray",
                          },
                        },
                      ]}
                      slotProps={{
                        legend: {
                          hidden: true,
                        },
                        tooltip: {
                          formatter: (value, props) => [
                            { label: "Cliente", value: props.label },
                            {
                              label: "Porcentaje",
                              value: `${value.toFixed(2)}%`,
                            },
                            { label: "Kilos", value: `${props.kilos} kg` },
                            {
                              label: "Total Butano",
                              value: `${totalButano} kg`,
                            },
                          ],
                        },
                      }}
                      width={400}
                      height={300}
                    />
                  </Box>

                  {/* Leyenda personalizada */}
                  <Box sx={{ minWidth: 200 }}>
                    {[
                      ...topClientes
                        .filter((c) => c.kilos_vendidos_butano > 0)
                        .map((c, i) => ({
                          label: c.cliente,
                          color: COLORS[(i + colorOffset) % COLORS.length],
                          kilos: c.kilos_vendidos_butano,
                        })),
                      {
                        label: "Otros",
                        color: "#e0e0e0",
                        kilos: Math.max(
                          0,
                          totalButano -
                            topClientes.reduce(
                              (sum, c) => sum + (c.kilos_vendidos_butano || 0),
                              0
                            )
                        ),
                      },
                    ].map((item, idx) => (
                      <Box key={idx} display="flex" alignItems="center" mb={1}>
                        <Box
                          sx={{
                            width: 14,
                            height: 14,
                            borderRadius: "50%",
                            backgroundColor: item.color,
                            mr: 1,
                          }}
                        />
                        <Typography variant="body2" sx={{ fontSize: 14 }}>
                          {item.label} — {item.kilos} kg <strong>({item.kilos>0?((item.kilos / totalButano)*100).toFixed(2):"0"}%)</strong>
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Gráfico de Propano */}
        <Grid item xs={12} md={4}>
          <Card sx={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
              boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
              borderRadius: "12px",
              transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
              borderLeft: "4px solid #1F618D",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
              },
            }}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={3}>
                <LocalFireDepartmentIcon sx={{ color: "#FF8C42", mr: 1 }} />
                <Typography
                  variant="h6"
                  sx={{ color: "#1F618D", fontWeight: "bold" }}
                >
                  Propano ({totalPropano || "0"} kg)
                </Typography>
              </Box>

              {loadingKgTipos ? (
                <Box display="flex" justifyContent="center" height={300}>
                  <CircularProgress sx={{ color: "#1F618D" }} />
                </Box>
              ) : (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ flexWrap: "wrap", gap: 4 }}
                >
                  <Box sx={{ 
                    width: 400, 
                    height: 320,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // marginLeft:12
                  }}>
                    <PieChart
                      series={[
                        {
                          data: [
                            ...topClientes
                              .filter((c) => c.kilos_vendidos_propano > 0)
                              .map((c, i) => ({
                                id: c.id,
                                value:
                                  totalPropano > 0
                                    ? (c.kilos_vendidos_propano /
                                        totalPropano) *
                                      100
                                    : 0,
                                label: c.cliente,
                                color: COLORS[(i + colorOffset) % COLORS.length],
                                kilos: c.kilos_vendidos_propano,
                              })),
                            {
                              id: "otros-propano",
                              value:
                                totalPropano > 0
                                  ? ((totalPropano -
                                      topClientes.reduce(
                                        (sum, c) =>
                                          sum + (c.kilos_vendidos_propano || 0),
                                        0
                                      )) /
                                      totalPropano) *
                                    100
                                  : 0,
                              label: "Otros",
                              color: "#e0e0e0",
                              kilos: Math.max(
                                0,
                                totalPropano -
                                  topClientes.reduce(
                                    (sum, c) =>
                                      sum + (c.kilos_vendidos_propano || 0),
                                    0
                                  )
                              ),
                            },
                          ],
                          innerRadius: 30,
                          paddingAngle: 3,
                          cx: 200,
                          // outerRadius: 80,
                          // paddingAngle: 1,
                          // cornerRadius: 3,
                          arcLabel: (item) =>
                            item.value > 5 ? `${item.value.toFixed(1)}%` : "",
                          highlightScope: {
                            faded: "global",
                            highlighted: "item",
                          },
                          faded: {
                            additionalRadius: -15,
                            color: "gray",
                          },
                          
                        },
                      ]}
                      slotProps={{
                        legend: {
                          hidden: true,
                        },
                        // tooltip: {
                        //   formatter: (value, props) => [
                        //     { label: "Cliente", value: props.label },
                        //     {
                        //       label: "Porcentaje",
                        //       value: `${value.toFixed(2)}%`,
                        //     },
                        //     { label: "Kilos", value: `${props.kilos} kg` },
                        //     {
                        //       label: "Total Propano",
                        //       value: `${totalPropano} kg`,
                        //     },
                        //   ],
                        // },
                      }}
                      
                      width={400}
                      height={300}
                    />
                  </Box>
                  {/* Leyenda personalizada */}
                  <Box sx={{ minWidth: 200 }}>
                    {[
                      ...topClientes
                        .filter((c) => c.kilos_vendidos_propano > 0)
                        .map((c, i) => ({
                          label: c.cliente,
                          color: COLORS[(i + colorOffset) % COLORS.length],
                          kilos: c.kilos_vendidos_propano,
                        })),
                      {
                        label: "Otros",
                        color: "#e0e0e0",
                        kilos: Math.max(
                          0,
                          totalPropano -
                            topClientes.reduce(
                              (sum, c) => sum + (c.kilos_vendidos_propano || 0),
                              0
                            )
                        ),
                      },
                    ].map((item, idx) => (
                      <Box key={idx} display="flex" alignItems="center" mb={1}>
                        <Box
                          sx={{
                            width: 14,
                            height: 14,
                            borderRadius: "50%",
                            backgroundColor: item.color,
                            mr: 1,
                          }}
                        />
                        <Typography variant="body2" sx={{ fontSize: 14 }}>
                          {item.label} — {item.kilos} kg <strong>({item.kilos>0?((item.kilos / totalPropano)*100).toFixed(2):"0"}%)</strong>
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      </Box>
    </div>
  );
}

export default RankingVulnera;
